
define('text!presentation/shell/views/shell.html',[],function () { return '<div data-bind="css: shellName">\n    <!--\n         ko compose: {\n             model: shellViewModel,\n             activate: true,\n             activationData: params\n          }\n     -->\n    <!-- /ko -->\n</div>\n';});

